import * as React from "react";
import { SVGProps } from "react";

const Metal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 601 455"
    {...props}
  >
    <linearGradient
      id="a"
      x1={-0.908}
      x2={805.044}
      y1={226.477}
      y2={310.198}
      gradientTransform="matrix(1 0 0 -1 0 458.4)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#4400e2" />
      <stop offset={0.041} stopColor="#7013c5" />
      <stop offset={0.087} stopColor="#9a25aa" />
      <stop offset={0.133} stopColor="#bc3494" />
      <stop offset={0.18} stopColor="#d73f82" />
      <stop offset={0.228} stopColor="#ea4876" />
      <stop offset={0.278} stopColor="#f54c6e" />
      <stop offset={0.33} stopColor="#f94e6c" />
      <stop offset={1} stopColor="#ffd402" />
    </linearGradient>
    <path
      fill="url(#a)"
      d="M37.9 0C16.9 0 0 17 0 37.9v380c0 20.9 16.9 37.9 37.9 37.9s37.9-17 37.9-37.9v-380C75.7 17 58.8 0 37.9 0z"
    />
    <linearGradient
      id="b"
      x1={4.701}
      x2={810.653}
      y1={172.482}
      y2={256.202}
      gradientTransform="matrix(1 0 0 -1 0 458.4)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#4400e2" />
      <stop offset={0.041} stopColor="#7013c5" />
      <stop offset={0.087} stopColor="#9a25aa" />
      <stop offset={0.133} stopColor="#bc3494" />
      <stop offset={0.18} stopColor="#d73f82" />
      <stop offset={0.228} stopColor="#ea4876" />
      <stop offset={0.278} stopColor="#f54c6e" />
      <stop offset={0.33} stopColor="#f94e6c" />
      <stop offset={1} stopColor="#ffd402" />
    </linearGradient>
    <path
      fill="url(#b)"
      d="M563.3 0c-20.9 0-37.9 17-37.9 37.9v380c0 20.9 17 37.9 37.9 37.9s37.9-17 37.9-37.9v-380c0-20.9-17-37.9-37.9-37.9z"
    />
    <linearGradient
      id="c"
      x1={0.962}
      x2={806.914}
      y1={208.477}
      y2={292.198}
      gradientTransform="matrix(1 0 0 -1 0 458.4)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#4400e2" />
      <stop offset={0.041} stopColor="#7013c5" />
      <stop offset={0.087} stopColor="#9a25aa" />
      <stop offset={0.133} stopColor="#bc3494" />
      <stop offset={0.18} stopColor="#d73f82" />
      <stop offset={0.228} stopColor="#ea4876" />
      <stop offset={0.278} stopColor="#f54c6e" />
      <stop offset={0.33} stopColor="#f94e6c" />
      <stop offset={1} stopColor="#ffd402" />
    </linearGradient>
    <path
      fill="url(#c)"
      d="M213 79c-20.9 0-37.9 16.9-37.9 37.9v222c0 20.9 17 37.9 37.9 37.9s37.9-17 37.9-37.9v-222c0-20.9-17-37.9-37.9-37.9z"
    />
    <linearGradient
      id="d"
      x1={2.79}
      x2={808.741}
      y1={190.882}
      y2={274.603}
      gradientTransform="matrix(1 0 0 -1 0 458.4)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#4400e2" />
      <stop offset={0.041} stopColor="#7013c5" />
      <stop offset={0.087} stopColor="#9a25aa" />
      <stop offset={0.133} stopColor="#bc3494" />
      <stop offset={0.18} stopColor="#d73f82" />
      <stop offset={0.228} stopColor="#ea4876" />
      <stop offset={0.278} stopColor="#f54c6e" />
      <stop offset={0.33} stopColor="#f94e6c" />
      <stop offset={1} stopColor="#ffd402" />
    </linearGradient>
    <path
      fill="url(#d)"
      d="M388.2 142.8c-20.9 0-37.9 17-37.9 37.9v93.7c0 20.9 17 37.9 37.9 37.9s37.9-17 37.9-37.9v-93.7c-.1-21-17-37.9-37.9-37.9z"
    />
  </svg>
);

export default Metal;
